<template>
  <v-dialog v-model="isOpen" max-width="960" persistent>
    <v-card class="video-dialog">
      <div class="video-header">
        <div class="video-title">{{ videoName }}</div>
        <v-btn icon class="close-btn" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <iframe
          v-if="videoLink"
          :src="videoLink"
          width="100%"
          height="540"
          frameborder="0"
          allow="autoplay; encrypted-media"
          allowfullscreen
          class="video-player"
      ></iframe>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from "lodash";

export default {
  name: "LecturePlayerPopup",
  props: ['isOpen', 'videoDataProps'],
  data() {
    return {
      videoName: "",
      videoLink: "",
    }
  },
  watch: {
    isOpen(value) {
      if (value) {
        if (!_.isEmpty(this.videoDataProps)) {
          this.videoName = this.videoDataProps.title;
          const videoId = this.extractYouTubeId(this.videoDataProps.url);
          this.videoLink = `https://www.youtube.com/embed/${videoId}?rel=0&autoplay=1&start=0`;
        }
      }
    }
  },
  methods: {
    close() {
      this.videoLink = "";
      this.$emit("close");
    },
    extractYouTubeId(link) {
      const regex = /(?:v=|youtu\.be\/)([^&#]+)/;
      const match = link.match(regex);
      return match ? match[1] : "";
    }
  }
};
</script>

<style scoped>
.video-dialog {
  position: relative;
  padding: 0;
  overflow: hidden;
}

.video-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #ddd;
}

.video-title {
  font-size: 21px;
  font-weight: bold;
  color: #333;
}

.close-btn {
  background-color: #ffffffcc;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}

.close-btn:hover {
  background-color: #eeeeee;
}

.video-player {
  margin-bottom: -5px;
}

</style>
